/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index accordion to autogenerate all the components and extensions
 * Used by "prepareAccordions"
 */

import Accordion from './accordion/Accordion'
export * from './accordion/Accordion'
export default Accordion
